/**
 *  文件上传相关接口
 */
import { axios } from '@/utils/request'

/**
 * 富文本编辑器文件上传
 * @param {*} formData //表单数据 fileId=文件id file=文件内容
 * @param {*} cancelToken // axios 取消标志
 * @param {*} onUploadProgress // 上传进度回调用
 */
export function richEditorUpload (formData, cancelToken, onUploadProgress) {
  return axios({
    url: '/upload/postFile',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    onUploadProgress: onUploadProgress,
    cancelToken: cancelToken
  })
}

/**
 * 使用扩展参数定制请求信息
 * @param {*} formData // 表单数据 fileId=文件id file=文件内容
 * @param {*} config // axios 扩展参数
 */
export function postFileWithConfig (formData, config) {
  return axios({
    url: '/upload/postFile',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    ...config
  })
}

/**
 * 普通文件上传
 * @param {*} formData // 表单数据 fileId=文件id file=文件内容
 */
export function postFile (formData) {
  return axios({
    url: '/upload/postFile',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData
  })
}

/**
 * 使用扩展参数定制请求信息
 * @param {*} formData // 表单数据 fileId=文件id file=文件内容
 * @param {*} config // axios 扩展参数
 */
export function putFileWithConfig (formData, config) {
  return axios({
    url: '/upload/putFile',
    method: 'put',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    ...config
  })
}

/**
 * 普通文件上传
 * @param {*} formData // 表单数据 fileId=文件id file=文件内容
 */
export function putFile (formData) {
  return axios({
    url: '/upload/putFile',
    method: 'put',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData
  })
}

/**
 * 复制文件
 * @param {*} formData // 表单数据 path=文件路径 source=源文件
 */
export function copyFile (formData) {
  return axios({
    url: '/upload/copyFile',
    method: 'put',
    params: formData
  })
}
